import React from "react";
import TabsSelector from "../../../Components/Atoms/TabsSelector";
import CustomerDetailInvoiceList from "./CustomerDetailInvoiceList";
import CustomerDetailEmailHistoryList from "./CustomerDetailEmailHistoryList";
import CustomerDetailTransactionsList from "./CustomerDetailTransactionsList";
import { useSettingsStore } from "../../../Store/Settings";
import CustomerDetailCustomFieldsTab from "./CustomerDetailCustomFieldsTab";

type TabType = "invoices" | "email_history" | "transactions" | "custom_fields";

const tabs: { key: TabType; displayValue: string }[] = [
  { key: "invoices", displayValue: "Invoices" },
  { key: "email_history", displayValue: "Email History" },
  { key: "transactions", displayValue: "Transactions" },
  { key: "custom_fields", displayValue: "Custom Fields" }
];

const CustomerDetailLeftTables: React.FC = () => {
  const [currentActiveTab, setCurrentActiveTab] = React.useState<TabType>("invoices");
  const { settings } = useSettingsStore();
  const tabsToShow = settings?.payment_custom_field_filter_enabled
    ? tabs
    : tabs.filter(tab => tab.key !== "custom_fields");

  return (
    <div className="col-span-2 overflow-x-auto pt-1">
      <TabsSelector
        tabs={tabsToShow}
        currentActiveTab={currentActiveTab}
        setCurrentActiveTab={setCurrentActiveTab}
      />
      <div>
        {currentActiveTab === "invoices" && <CustomerDetailInvoiceList />}
        {currentActiveTab === "email_history" && <CustomerDetailEmailHistoryList />}
        {currentActiveTab === "transactions" && <CustomerDetailTransactionsList />}
        {currentActiveTab === "custom_fields" && <CustomerDetailCustomFieldsTab />}
      </div>
    </div>
  );
};

export default CustomerDetailLeftTables;
